/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applySelectionCommitToState from './helpers/applySelectionCommitToState';
import { getSearchRangeSelectionPlan } from './helpers/applySelection';
import { getEntitySelectionContext } from './helpers/selectionContext';
import { buildSelectionKey, isSelectableItem } from './helpers/selectionKey';
import toSelectionEntry from './helpers/toSelectionEntry';

export const selectProductItem = createAction('products/selectProductItem');

export const reducer = (builder) => {
  builder
    .addCase(selectProductItem, (state, { payload }) => {
      const { item, value, isRange } = payload;

      if (!isRange) {
        if (!isSelectableItem(item)) return;

        const key = buildSelectionKey(item);
        if (value) {
          const entry = toSelectionEntry(item);
          applySelectionCommitToState(state, {
            addEntries: [entry],
            lastClickedKey: key,
            context: getEntitySelectionContext(item),
            source: 'search',
            switchToEntry: entry,
          });
        } else {
          applySelectionCommitToState(state, {
            removeKeys: [key],
            lastClickedKey: key,
            source: 'search',
          });
        }
        return;
      }

      const plan = getSearchRangeSelectionPlan(
        state.ui.selection,
        state.search.items,
        payload,
      );

      if (!plan) return;

      applySelectionCommitToState(state, {
        ...plan,
        source: 'search',
        switchToEntry: toSelectionEntry(item),
      });
    });
};
